export const SYARYO_STATUS = {
  ADJUSTING: 1,
  ARRANGED: 2,
  PICKED_UP: 3,
  DELIVERED: 4,
  COMPLETED: 5,
  CANCELED: 9,
}

export const SYARYO_STATUS_LABELS = {
  [SYARYO_STATUS.ADJUSTING]: '調整中',
  [SYARYO_STATUS.ARRANGED]: '手配完了',
  [SYARYO_STATUS.PICKED_UP]: '引取完了',
  [SYARYO_STATUS.DELIVERED]: '納車完了',
  [SYARYO_STATUS.COMPLETED]: '受注完了',
  [SYARYO_STATUS.CANCELED]: 'キャンセル',
}

export const getSyaryoStatusList = () => {
  return Object.keys(SYARYO_STATUS).map((key) => {
    const value = SYARYO_STATUS[key]
    return {
      value,
      text: SYARYO_STATUS_LABELS[value],
    }
  })
}

export const getSyaryoStatus = (value, isJizenRenraku) => {
  if (isJizenRenraku === 1 && value === SYARYO_STATUS.COMPLETED) {
    return {
      value: SYARYO_STATUS.ADJUSTING,
      text: SYARYO_STATUS_LABELS[SYARYO_STATUS.ADJUSTING],
    }
  }
  return getSyaryoStatusList().find((item) => item.value === value)
}

/**
 * ステータスが調整中以降かどうか
 * @param {number} value ステータス
 * @returns {boolean} ステータスが調整中以降かどうか
 */
export const isSyaryoStatusAfterAdjusting = (value) => {
  return value > SYARYO_STATUS.ADJUSTING
}



// WEBPACK FOOTER //
// ./src/constants/syaryoStatus.js